import React from 'react';

import { routes } from '@config/routes';
import { SchoolEditEntry } from '@modules/schools/entries';

import type { Page } from '@modules/types/page';

const SchoolsEditPage = (props: Page): React.ReactElement => (
    <SchoolEditEntry backRouteUrl={routes.schools.path} {...props} />
);

export default SchoolsEditPage;
